/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectDeliverableType = {
    Single: 'SINGLE',
    Lot: 'LOT'
} as const;
export type ProjectDeliverableType = typeof ProjectDeliverableType[keyof typeof ProjectDeliverableType];


export function instanceOfProjectDeliverableType(value: any): boolean {
    for (const key in ProjectDeliverableType) {
        if (Object.prototype.hasOwnProperty.call(ProjectDeliverableType, key)) {
            // @ts-ignore
            if (ProjectDeliverableType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectDeliverableTypeFromJSON(json: any): ProjectDeliverableType {
    return ProjectDeliverableTypeFromJSONTyped(json, false);
}

export function ProjectDeliverableTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDeliverableType {
    return json as ProjectDeliverableType;
}

export function ProjectDeliverableTypeToJSON(value?: ProjectDeliverableType | null): any {
    return value as any;
}

